document.addEventListener('submit', async (event) => {
  const form = event.target;
  if (!form.matches('.product-card-form, .product-form')) return;
  if (!window.fetch || !window.FormData) return;

  event.preventDefault();
  const button = form.querySelector('button[type="submit"]');
  const originalText = button ? button.textContent : '';

  try {
    if (button) {
      button.disabled = true;
      button.textContent = 'Agregando...';
    }

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    });

    if (!response.ok) throw new Error('Cart add failed');
    await refreshCartCount();
    showCartToast();
  } catch (error) {
    form.submit();
  } finally {
    if (button) {
      button.disabled = false;
      button.textContent = originalText;
    }
  }
});

async function refreshCartCount() {
  try {
    const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    if (!response.ok) return;
    const cart = await response.json();
    document.querySelectorAll('.count').forEach((count) => {
      count.textContent = cart.item_count;
    });
  } catch (error) {
    return;
  }
}

function showCartToast() {
  const toast = document.querySelector('[data-cart-toast]');
  if (!toast) return;
  toast.hidden = false;
  requestAnimationFrame(() => toast.classList.add('open'));
}

function closeCartToast() {
  const toast = document.querySelector('[data-cart-toast]');
  if (!toast) return;
  toast.classList.remove('open');
  window.setTimeout(() => {
    toast.hidden = true;
  }, 180);
}

document.addEventListener('click', (event) => {
  if (event.target.closest('[data-cart-toast-close]')) {
    closeCartToast();
  }
});

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') closeCartToast();
});

document.addEventListener('click', (event) => {
  const button = event.target.closest('.gallery-button');
  if (!button) return;

  const media = button.closest('.detail-media');
  const carousel = media ? media.querySelector('[data-product-carousel]') : null;
  const slideIndex = Number(button.dataset.slideTarget || 0);
  const slide = carousel ? carousel.querySelector(`[data-slide-index="${slideIndex}"]`) : null;
  if (!carousel || !slide) return;

  slide.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });

  button.parentElement.querySelectorAll('.gallery-button').forEach((item) => {
    item.classList.toggle('active', item === button);
  });
});

document.querySelectorAll('[data-product-carousel]').forEach((carousel) => {
  let frame = 0;
  carousel.addEventListener('scroll', () => {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(() => {
      const index = Math.round(carousel.scrollLeft / carousel.clientWidth);
      const media = carousel.closest('.detail-media');
      if (!media) return;
      media.querySelectorAll('.gallery-button').forEach((button) => {
        button.classList.toggle('active', Number(button.dataset.slideTarget) === index);
      });
    });
  }, { passive: true });
});
